import {Subject, Observer} from 'rx';
import pick from 'lodash/pick';
import {saveState} from './persistentState';

export default (keys) => {
    var persistent$ = new Subject();

    var observer = Observer.create(
        function (state) {
            saveState(state);
            //console.log('Do Next: %s', state);
        },
        function (err) {
            //console.log('Do Error: %s', err);
        },
        function () {
            //console.log('Do Completed');
        }
    );

    persistent$
        .throttle(1000)
        .map(state => pick(state, keys))
        .subscribe(observer);

    return store => next => action => {
        persistent$.onNext(store.getState());
        return next(action);
    };
};
